__turbopack_context__.v({
  "blog_detail": "styles-module-scss-module__ixliEG__blog_detail",
  "blog_detail_article": "styles-module-scss-module__ixliEG__blog_detail_article",
  "blog_detail_article_categories": "styles-module-scss-module__ixliEG__blog_detail_article_categories",
  "blog_detail_article_main": "styles-module-scss-module__ixliEG__blog_detail_article_main",
  "blog_detail_article_meta": "styles-module-scss-module__ixliEG__blog_detail_article_meta",
  "blog_detail_article_support": "styles-module-scss-module__ixliEG__blog_detail_article_support",
  "blog_detail_buttons": "styles-module-scss-module__ixliEG__blog_detail_buttons",
  "blog_detail_container": "styles-module-scss-module__ixliEG__blog_detail_container",
  "blog_detail_content": "styles-module-scss-module__ixliEG__blog_detail_content",
  "blog_detail_header": "styles-module-scss-module__ixliEG__blog_detail_header",
  "blog_detail_header_container": "styles-module-scss-module__ixliEG__blog_detail_header_container",
  "blog_detail_header_img": "styles-module-scss-module__ixliEG__blog_detail_header_img",
  "blog_detail_header_text": "styles-module-scss-module__ixliEG__blog_detail_header_text",
  "blog_detail_key_takeaways": "styles-module-scss-module__ixliEG__blog_detail_key_takeaways",
  "blog_detail_mobile_support": "styles-module-scss-module__ixliEG__blog_detail_mobile_support",
  "blog_detail_social": "styles-module-scss-module__ixliEG__blog_detail_social",
  "blog_detail_social_link": "styles-module-scss-module__ixliEG__blog_detail_social_link",
  "blog_detail_support": "styles-module-scss-module__ixliEG__blog_detail_support",
});
